import {
  SET_SEGMENT_LOADER,
  SET_SEGMENTS_LIST,
  SET_SELECTED_SEGMENT,
  SET_IS_SEGMENT_ASSIGNED
} from '../../actions/segment/segmentActions';

const initialState = {
  segmentLoader: true,
  segmentsList: [],
  selectedSegment: {},
  isSegmentAssigned: false,
};

export const segmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SEGMENT_LOADER:
      return {
        ...state,
        segmentLoader: action?.payload || [],
      };
    case SET_SEGMENTS_LIST:
      return {
        ...state,
        segmentsList: action?.payload || [],
      };

    case SET_SELECTED_SEGMENT:
      return {
        ...state,
        selectedSegment: action?.payload || [],
      };

      case SET_IS_SEGMENT_ASSIGNED:
      return {
        ...state,
        isSegmentAssigned: action?.payload || false,
      };

    default:
      return state;
  }
};
